export default __webpack_public_path__ + "static/media/img-payslip.0947ca63.png";